
export default function HonorCard(props){
    return (
        <div data-aos="fade-up" data-aos-duration="500" data-aos-offset="100"  className="w-full md:w-2/6 bg-dark-100 rounded-md py-4 px-4">
            {/* <img src={props.img} className="w-20 max-h-20 mx-auto" alt={props.name}></img> */}
            <div className="mt-2">
                <h1 className="font-bold md:text-xl text-center">{props.name}</h1>
                <p className="font-light md:text-lg text-center">{props.made}</p>
                <a href={props.link} target="_blank" rel="noreferrer">
                <img className="projects-img" src={props.image}/>
                </a>
                <p className="font-light text-gray-400">{props.desc}.</p>
                <br/>
                <p className="font-light text-gray-400"> Tech used: {props.tech}</p>
            </div>
        </div>
    )
} 
